import { useIntl } from 'react-intl';

import { PanelType } from '~/enums/PanelType';

interface Panel_DEPRECATED {
  icon: string;
  label: string;
  tooltip: string;
  value: string;
}

export const usePanels = () => {
  const intl = useIntl();

  const panels: Record<PanelType, Panel_DEPRECATED> = {
    [PanelType.ActivityLogs]: {
      icon: 'expiring',
      label: intl.formatMessage({
        id: 'UsePanels.activityLogsLabel',
        defaultMessage: 'activity logs',
        description: 'Activity logs panel label',
      }),
      tooltip: intl.formatMessage({
        id: 'UsePanels.activityLogsTooltip',
        defaultMessage: 'Activity Logs',
        description: 'Activity logs panel tooltip',
      }),
      value: 'activityLogs',
    },
    [PanelType.ClauseLibrary]: {
      icon: 'library',
      label: intl.formatMessage({
        id: 'UsePanels.clauseLibraryLabel',
        defaultMessage: 'Clause Library',
        description: 'Clause library panel label',
      }),
      tooltip: intl.formatMessage({
        id: 'UsePanels.clauseLibraryTooltip',
        defaultMessage: 'Clause Library',
        description: 'Clause library panel tooltip',
      }),
      value: 'clauseLibrary',
    },
    [PanelType.AskAI]: {
      icon: 'evisort-ai-static',
      label: intl.formatMessage({
        id: 'UsePanels.askAiLabel',
        defaultMessage: 'ask AI',
        description: 'Ask AI panel label',
      }),
      tooltip: intl.formatMessage({
        id: 'UsePanels.askAiTooltip',
        defaultMessage: 'Ask AI',
        description: 'Ask AI panel tooltip',
      }),
      value: 'askAI',
    },
    [PanelType.PlaybookAgent]: {
      icon: 'ai-review',
      label: intl.formatMessage({
        id: 'UsePanels.aiReviewLabel',
        defaultMessage: 'AI Review',
        description: 'AI Review panel label',
      }),
      tooltip: intl.formatMessage({
        id: 'UsePanels.aiReviewTooltip',
        defaultMessage: 'AI Review',
        description: 'AI Review panel tooltip',
      }),
      value: 'playbookAgent',
    },
    [PanelType.Comments]: {
      icon: 'message',
      label: intl.formatMessage({
        id: 'UsePanels.commentsLabel',
        defaultMessage: 'comments',
        description: 'Comments panel label',
      }),
      tooltip: intl.formatMessage({
        id: 'UsePanels.commentsTooltip',
        defaultMessage: 'Comments',
        description: 'Comments panel tooltip',
      }),
      value: 'comments',
    },
    [PanelType.CycleTimeTracker]: {
      icon: 'turn-tracking',
      label: intl.formatMessage({
        id: 'UsePanels.cycleTimeTrackerLabel',
        defaultMessage: 'Cycle time tracker',
        description: 'Cycle time tracker panel label',
      }),
      tooltip: intl.formatMessage({
        id: 'UsePanels.cycleTimeTrackerTooltip',
        defaultMessage: 'Cycle Time Tracker',
        description: 'Cycle time tracker panel tooltip',
      }),
      value: 'cycleTimeTracker',
    },
    [PanelType.DocumentDetails]: {
      icon: 'field-file',
      label: intl.formatMessage({
        id: 'UsePanels.documentDetailsLabel',
        defaultMessage: 'document details',
        description: 'Document details panel label',
      }),
      tooltip: intl.formatMessage({
        id: 'UsePanels.documentDetailsTooltip',
        defaultMessage: 'Document Details',
        description: 'Document details panel tooltip',
      }),
      value: 'documentDetails',
    },
    [PanelType.GenAi]: {
      icon: 'automation',
      label: intl.formatMessage({
        id: 'UsePanels.genAiLabel',
        defaultMessage: 'AI Drafting Tools',
        description: 'AI drafting tools panel label',
      }),
      tooltip: intl.formatMessage({
        id: 'UsePanels.genAiTooltip',
        defaultMessage: 'AI Drafting Tools',
        description: 'AI drafting tools panel tooltip',
      }),
      value: 'genAi',
    },
    [PanelType.GroupMembership]: {
      icon: 'groups',
      label: intl.formatMessage({
        id: 'UsePanels.groupsLabel',
        defaultMessage: 'groups',
        description: 'Groups panel label',
      }),
      tooltip: intl.formatMessage({
        id: 'UsePanels.groupsTooltip',
        defaultMessage: 'Groups',
        description: 'Groups panel tooltip',
      }),
      value: 'groupMembership',
    },
    [PanelType.IntakeForm]: {
      icon: 'checklist',
      label: intl.formatMessage({
        id: 'UsePanels.intakeFormLabel',
        defaultMessage: 'intake form',
        description: 'Intake form panel label',
      }),
      tooltip: intl.formatMessage({
        id: 'UsePanels.intakeFormTooltip',
        defaultMessage: 'Intake Form',
        description: 'Intake form panel tooltip',
      }),
      value: 'intakeForm',
    },
    [PanelType.TrackChanges]: {
      icon: 'review',
      label: intl.formatMessage({
        id: 'UsePanels.trackChangesLabel',
        defaultMessage: 'Track changes',
        description: 'Track changes panel label',
      }),
      tooltip: intl.formatMessage({
        id: 'UsePanels.trackChangesTooltip',
        defaultMessage: 'Track changes',
        description: 'Track changes panel tooltip',
      }),
      value: 'revisions',
    },
  };
  return {
    panels,
  };
};
